import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { isAuthenticated, logout } from "../utils/authUtils";
import clientService from "../services/clientService";
import Cookies from "js-cookie";
import { getBaseUrl } from "../utils/apiHelper";
import '../css/Navbar.css';

const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState("");
    const location = useLocation();

    useEffect(() => {
        const checkAuth = () => {
            const authStatus = isAuthenticated();
            setLoggedIn(authStatus);
            if (authStatus) {
                const storedUsername = Cookies.get("username");
                setUsername(storedUsername || "User");
            }
        };

        checkAuth();

        const fetchClients = async () => {
            try {
                await clientService.getAllClients();
            } catch (error) {
                console.error("Error fetching clients:", error.message);
            }
        };

        if (loggedIn) {
            fetchClients();
        }

        const intervalId = setInterval(checkAuth, 30000);
        return () => clearInterval(intervalId);
    }, [loggedIn, location]);

    const handleLogout = () => {
        logout();
        Cookies.remove("isAdmin");
        setLoggedIn(false);
        setOpen(false);
    };

    const closeMenu = () => setOpen(false);

    const isAdmin = Cookies.get("isAdmin") === "true";
    const isDevMode = getBaseUrl() !== "https://autofolio-backend-prod.up.railway.app";

    // Extract first name from email if possible
    const displayName = username.includes('@')
        ? username.split('@')[0].split('.').map(n => n.charAt(0).toUpperCase() + n.slice(1)).join(' ')
        : username;

    return (
        <>
            <nav className="navbar">
                {/* Left Section - Admin Badge & API Indicator */}
                <div className="navbar-left">
                    {loggedIn && isAdmin && (
                        <div className="admin-badge-container">
                            <span className="admin-badge">Admin</span>
                        </div>
                    )}

                    {isDevMode && (
                        <div className="api-indicator">
                            {getBaseUrl().replace('http://', '').replace('https://', '')}
                        </div>
                    )}
                </div>

                {/* Center Section - Welcome & Logo */}
                {loggedIn && (
                    <div className="navbar-center">
                        <div className="navbar-welcome">
                            <div className="welcome-text">
                                <span className="welcome-label">Welcome</span>
                                <span className="welcome-name">{displayName}</span>
                            </div>
                        </div>
                        <div className="navbar-logo">
                            <img src="/images/logo.png" alt="Logo" className="logo" />
                            <span className="version-badge">v1.19</span>
                        </div>
                    </div>
                )}

                {/* Mobile Menu Toggle */}
                <button className="menu-toggle" onClick={() => setOpen(!open)}>
                    {open ? "✕" : "☰"}
                </button>

                {/* Right Section - Navigation Links */}
                <div className={`navbar-right ${open ? "open" : ""}`}>
                    <div className="nav-links">
                        {!loggedIn ? (
                            <>
                                <NavLink
                                    to="/register"
                                    className={({ isActive }) => (isActive ? "active" : "")}
                                    onClick={closeMenu}
                                >
                                    Register
                                </NavLink>
                                <NavLink
                                    to="/login"
                                    className={({ isActive }) => (isActive ? "active" : "")}
                                    onClick={closeMenu}
                                >
                                    Login
                                </NavLink>
                            </>
                        ) : (
                            <>
                                <NavLink
                                    to="/members"
                                    className={({ isActive }) => (isActive ? "active" : "")}
                                    onClick={closeMenu}
                                >
                                    Members
                                </NavLink>
                                {isAdmin && (
                                    <NavLink
                                        to="/admin"
                                        className={({ isActive }) => (isActive ? "active" : "")}
                                        onClick={closeMenu}
                                    >
                                        Admin
                                    </NavLink>
                                )}
                                {isAdmin && (
                                    <NavLink
                                        to="/create-client"
                                        className={({ isActive }) => (isActive ? "active" : "")}
                                        onClick={closeMenu}
                                    >
                                        Client
                                    </NavLink>
                                )}
                                {isAdmin && (
                                    <NavLink
                                        to="/user-activity"
                                        className={({ isActive }) => (isActive ? "active" : "")}
                                        onClick={closeMenu}
                                    >
                                        User Activity
                                    </NavLink>
                                )}
                            </>
                        )}
                    </div>
                    {loggedIn && (
                        <button onClick={handleLogout} className="logout-btn">
                            Logout
                        </button>
                    )}
                </div>
            </nav>

            {/* Mobile overlay */}
            {open && (
                <div className="mobile-overlay visible" onClick={closeMenu} />
            )}
        </>
    );
};

export default Navbar;
